import React from "react";
import * as S from "./styles";
import { convertISODateMode3, moneyMask } from "~/utils/mask";

const InvoiceSummaryCard = ({ data }) => {
    console.log("DATA COMPLETA:", data);
    return (
        <S.InvoiceSummaryBox>
            <S.SummaryColumn>
                <S.BoxLabel>Fatura atual</S.BoxLabel>
                <S.BoxValue>
                    {moneyMask(data?.saldoFaturaAtual)}
                </S.BoxValue>
            </S.SummaryColumn>

            <S.SummaryColumn align="flex-end">
                <S.StatusTags status={data?.status}>
                    {data?.status || ""}
                </S.StatusTags>

                {data?.status === "PAGA" && data?.dataPagamento && (
                    <S.StatusDate>
                        em {convertISODateMode3(data.dataPagamento)}
                    </S.StatusDate>
                )}
            </S.SummaryColumn>
        </S.InvoiceSummaryBox>
    );
};

export default InvoiceSummaryCard;